import { LicenseInfo, generateLicense } from '@mui/x-license';

import type { LicenseModel, PlanScope } from '@mui/x-license';

const orderNumber = '';
const expiryDate = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000); // 1 year from now
const planScope: PlanScope = 'premium'; // 'pro' or 'premium'
const licenseModel: LicenseModel = 'perpetual'; // 'perpetual', 'annual', 'subscription'

const licenseKey = generateLicense({
  expiryDate,
  orderNumber,
  planScope,
  licenseModel,
  planVersion: 'Q3-2024',
});

LicenseInfo.setLicenseKey(licenseKey);
